

export const FETCH_SESSION_CODE = {
    DELAY: {
        SAVE_CREDENTIALS: 100,
        REDIRECT: 50
    }
};

export const CHECK_SESSION_STATE = {
    DISABLE_SESSION_STATE_VERIFICATION: false,
    CHECK_STATE_REQUESTS_MAX_INTERVAL: 5000,
    STATE_IFRAME_RESPONSE_TIME_LIMIT: 500,
    LOAD_STATE_IFRAME_TIME_LIMIT: 500,
    TOKEN_EXPIRE_SAFETY_NET: 600
};